import { Separator } from "@components/atoms/separator/index.client";
import { Link } from "@shopify/hydrogen";

interface props {
  article: Record<string, any>;
}
export function ArticlePreview({ article }: props) {
  return (
    <Link
      to={
        article.handle.includes("news/")
          ? article.handle
          : `/blogs/educational/${article.handle}`
      }
      className="flex gap-x-7 items-center w-full h-18 sm:h-38"
    >
      <img
        src={article.image.url}
        alt={article.image.altText ?? ""}
        className="min-w-18 w-18 sm:min-w-38 sm:w-38 h-full object-contain border border-custom-light-gray border-solid"
      />
      <div>
        <h1 className="uppercase text-xs sm:text-xl">{article.title}</h1>
        <Separator className="mt-1 sm:mt-1.5 mb-[5.5px] sm:mb-[10px]" />
        <span
          className="text-[10px] sm:text-xs overflow-hidden text-ellipsis leading-none sm:leading-3"
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
          }}
        >
          {article.content}
        </span>
      </div>
    </Link>
  );
}
